import React from 'react'

const CARDS = [
  {
    n: 'FEDIAF · AAFCO',
    title: 'Référentiels internationaux',
    body: 'Chaque ration est validée contre les recommandations FEDIAF (Europe) et AAFCO (US) les plus récentes.',
  },
  {
    n: '40+',
    title: 'Nutriments suivis',
    body: 'Protéines, lipides, calcium, phosphore, vitamines, oligo-éléments — rien n\'échappe à l\'algorithme.',
  },
  {
    n: 'Modules',
    title: 'Pathologies & physiologie',
    body: 'Croissance, insuffisance rénale, obésité, diabète — les contraintes spécifiques sont intégrées.',
  },
]

const Mission = () => (
  <section className="vt-section cred" id="mission">
    <div className="vt-shell">
      <span className="eyebrow" style={{ color: 'var(--coral-300)' }}>La science derrière Fetchy</span>
      <h2>Chiffré, sérieux, traçable jusqu'à la source.</h2>
      <p className="cred__lead">
        Chaque calcul s'appuie sur les référentiels FEDIAF et AAFCO, enrichis par la littérature vétérinaire. L'algorithme est transparent : vous voyez les chiffres, les sources, les limites.
      </p>

      <div className="cred__grid">
        {CARDS.map((c, i) => (
          <div className="cred__card" key={i}>
            <div className="cred__n">{c.n}</div>
            <div className="cred__ct">{c.title}</div>
            <div className="cred__cb">{c.body}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, marginBottom: 28, maxWidth: '54ch' }}>
        <span role="img" aria-label="cible" style={{ fontSize: 22, lineHeight: 1 }}>&#x1F3AF;</span>
        <p style={{ margin: 0, color: 'rgba(231,238,246,.78)', fontSize: 15, lineHeight: 1.6 }}>
          « On ne veut pas remplacer le nutritionniste — on veut que chaque véto puisse prescrire une ration solide, fondée sur la science, en 5 minutes. »
        </p>
      </div>

      <p style={{ color: 'rgba(231,238,246,.65)', fontSize: 14, margin: 0 }}>
        Fondé à l'École nationale vétérinaire d'Alfort et VetAgro Sup Lyon.{' '}
        <a href="https://arginine-formation.com" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--coral-300)', textDecoration: 'underline' }}>
          Se former avec Arginine →
        </a>
      </p>
    </div>
  </section>
)

export default Mission;
